/// <summary>
/// 地址信息
/// </summary>
export class ReverseAddressInfo {


	constructor() {
		this.address = null;
		this.addressDistance = null;
		this.addressPosition = null;
		this.city = null;
		this.formattedAddress = null;
		this.lat = null;
		this.lon = null;
		this.poi = null;
		this.poiDistance = null;
		this.poiPosition = null;
		this.road = null;
		this.roadDistance = null;
	}


	static GetReverseAddressInfo(jsonObj) {
		let addressInfo = null;
		if (jsonObj == null) return addressInfo;
		addressInfo = new ReverseAddressInfo();
		let resultNodeObject = jsonObj.result;
		addressInfo.formattedAddress = resultNodeObject.formatted_address;
		let locationObject = resultNodeObject.location;
		if(locationObject)
		{
			addressInfo.lat = locationObject.lat;
			addressInfo.lon = locationObject.lon;
		}
		
		let addComponentObj = resultNodeObject.addressComponent;
		if(addComponentObj)
		{
			addressInfo.address = addComponentObj.address;
			addressInfo.addressDistance = addComponentObj.address_distance;
			addressInfo.addressPosition = addComponentObj.address_position;
			addressInfo.city = addComponentObj.city;
			addressInfo.poi = addComponentObj.poi;
			addressInfo.poiDistance = addComponentObj.poi_distance;
			addressInfo.poiPosition = addComponentObj.poi_position;
			addressInfo.road = addComponentObj.road;
			addressInfo.roadDistance = addComponentObj.road_distance;
		}

		return addressInfo;
	}

}//end ReverseAddressInfo

